module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "hgroup"
  }, [_c('h3'), _vm._v(" "), _c('h1', [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "20%",
      "text-align": "center",
      "font-size": "1.2em"
    }
  }, [_vm._v("\n\tFor my friend Kathy Stohldrier who has expert taste and my friend Anthony Berin whose great smile should get him the job with the best tools when he grows up.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ab7daa9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap138427.vue
// module id = 66
// module chunks = 0